<aura-dialog-layout title="Proposer 3 créneaux de visite" [hideActions]="true">
  <div dialog-content class="w-full max-w-2xl mx-auto py-2 flex flex-col gap-6">
    <!-- Context Banner -->
    <div class="rounded-xl p-4 bg-primary-2 border border-primary-4 text-neutral-12 flex items-start gap-3">
      <mat-icon class="text-primary-11 shrink-0 mt-0.5">event_available</mat-icon>
      <div class="text-xs space-y-1">
        <p class="font-semibold text-primary-12 m-0">
          Organisation de la visite physique pour «
          {{ data.property.presentation.title || data.property.location.address?.city || 'Votre bien' }} »
        </p>
        <p class="text-neutral-11 m-0">
          Proposez 3 options de créneaux à l'agent immobilier qui choisira le créneau qui lui convient le
          mieux. Les créneaux doivent être programmés au minimum 24h à l'avance (J+1).
          @if (hasOpeningHours()) {
            Les jours de repos habituels de l'agent sont automatiquement désactivés.
          }
        </p>
      </div>
    </div>

    @if (data.excludedSlots && data.excludedSlots.length > 0) {
      <div class="rounded-xl p-4 bg-amber-2 border border-amber-4 text-amber-12 flex items-start gap-3">
        <mat-icon class="text-amber-11 shrink-0 mt-0.5">event_busy</mat-icon>
        <div class="text-xs space-y-1">
          <p class="font-semibold text-amber-12 m-0">Nouveaux créneaux demandés par l'agent immobilier</p>
          <p class="text-neutral-11 m-0">
            L'agent a indiqué qu'aucun des précédents créneaux ne lui convenait. Vous devez proposer des
            créneaux différents des précédents.
          </p>
        </div>
      </div>
    }

    <!-- 3 Slots Form Grid -->
    <div class="flex flex-col gap-4">
      <!-- Slot 1 -->
      <div class="rounded-xl border border-neutral-4 bg-neutral-1 p-4 flex flex-col gap-3 shadow-xs">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary-9 text-white text-xs font-bold"
            >
              1
            </span>
            <span class="text-sm font-bold text-neutral-12">Premier créneau</span>
          </div>
          <span class="text-xs font-medium text-neutral-10">Option prioritaire</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
          <!-- Date -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Date de visite</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              [min]="minDate"
              [max]="maxDate"
              [matDatepickerFilter]="dateFilter"
              [ngModel]="slots()[0].date"
              (dateChange)="updateSlotDate(0, $event.value)"
              placeholder="JJ/MM/AAAA"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker1" />
            <mat-datepicker #picker1 />
          </mat-form-field>

          <!-- Heure -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Heure de début</mat-label>
            <mat-select [ngModel]="slots()[0].time" (selectionChange)="updateSlotTime(0, $event.value)">
              @for (time of availableTimeSlots; track time) {
                <mat-option [value]="time">{{ time }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Durée -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Durée estimée</mat-label>
            <mat-select
              [ngModel]="slots()[0].durationMinutes"
              (selectionChange)="updateSlotDuration(0, $event.value)"
            >
              @for (opt of durationOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (isSlotExcluded(slots()[0])) {
          <div
            class="flex items-center gap-2 text-xs text-red-11 bg-red-2 border border-red-4 rounded-lg p-2.5"
          >
            <mat-icon class="text-base! text-red-11">error_outline</mat-icon>
            <span>Ce créneau a déjà été refusé par l'agent. Veuillez choisir une autre date ou heure.</span>
          </div>
        }
      </div>

      <!-- Slot 2 -->
      <div class="rounded-xl border border-neutral-4 bg-neutral-1 p-4 flex flex-col gap-3 shadow-xs">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-9 text-white text-xs font-bold"
            >
              2
            </span>
            <span class="text-sm font-bold text-neutral-12">Deuxième créneau</span>
          </div>
          <span class="text-xs font-medium text-neutral-10">Alternative</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
          <!-- Date -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Date de visite</mat-label>
            <input
              matInput
              [matDatepicker]="picker2"
              [min]="minDate"
              [max]="maxDate"
              [matDatepickerFilter]="dateFilter"
              [ngModel]="slots()[1].date"
              (dateChange)="updateSlotDate(1, $event.value)"
              placeholder="JJ/MM/AAAA"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker2" />
            <mat-datepicker #picker2 />
          </mat-form-field>

          <!-- Heure -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Heure de début</mat-label>
            <mat-select [ngModel]="slots()[1].time" (selectionChange)="updateSlotTime(1, $event.value)">
              @for (time of availableTimeSlots; track time) {
                <mat-option [value]="time">{{ time }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Durée -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Durée estimée</mat-label>
            <mat-select
              [ngModel]="slots()[1].durationMinutes"
              (selectionChange)="updateSlotDuration(1, $event.value)"
            >
              @for (opt of durationOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (isSlotExcluded(slots()[1])) {
          <div
            class="flex items-center gap-2 text-xs text-red-11 bg-red-2 border border-red-4 rounded-lg p-2.5"
          >
            <mat-icon class="text-base! text-red-11">error_outline</mat-icon>
            <span>Ce créneau a déjà été refusé par l'agent. Veuillez choisir une autre date ou heure.</span>
          </div>
        }
      </div>

      <!-- Slot 3 -->
      <div class="rounded-xl border border-neutral-4 bg-neutral-1 p-4 flex flex-col gap-3 shadow-xs">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-violet-9 text-white text-xs font-bold"
            >
              3
            </span>
            <span class="text-sm font-bold text-neutral-12">Troisième créneau</span>
          </div>
          <span class="text-xs font-medium text-neutral-10">Alternative</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
          <!-- Date -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Date de visite</mat-label>
            <input
              matInput
              [matDatepicker]="picker3"
              [min]="minDate"
              [max]="maxDate"
              [matDatepickerFilter]="dateFilter"
              [ngModel]="slots()[2].date"
              (dateChange)="updateSlotDate(2, $event.value)"
              placeholder="JJ/MM/AAAA"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker3" />
            <mat-datepicker #picker3 />
          </mat-form-field>

          <!-- Heure -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Heure de début</mat-label>
            <mat-select [ngModel]="slots()[2].time" (selectionChange)="updateSlotTime(2, $event.value)">
              @for (time of availableTimeSlots; track time) {
                <mat-option [value]="time">{{ time }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Durée -->
          <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
            <mat-label>Durée estimée</mat-label>
            <mat-select
              [ngModel]="slots()[2].durationMinutes"
              (selectionChange)="updateSlotDuration(2, $event.value)"
            >
              @for (opt of durationOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (isSlotExcluded(slots()[2])) {
          <div
            class="flex items-center gap-2 text-xs text-red-11 bg-red-2 border border-red-4 rounded-lg p-2.5"
          >
            <mat-icon class="text-base! text-red-11">error_outline</mat-icon>
            <span>Ce créneau a déjà été refusé par l'agent. Veuillez choisir une autre date ou heure.</span>
          </div>
        }
      </div>
    </div>

    <!-- Notes & Access Instructions -->
    <div class="flex flex-col gap-1.5">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Consignes d'accès et remarques (facultatif)</mat-label>
        <textarea
          matInput
          rows="3"
          [ngModel]="notes()"
          (ngModelChange)="notes.set($event)"
          placeholder="Ex : Digicode A1423, interphone Dupont, 2e étage sans ascenseur..."
        ></textarea>
      </mat-form-field>
    </div>

    <!-- Actions -->
    <div class="flex items-center justify-end gap-3 pt-3 border-t border-neutral-3">
      <button type="button" mat-button (click)="onCancel()" class="text-neutral-11 hover:text-neutral-12">
        Annuler
      </button>

      <button
        type="button"
        mat-flat-button
        class="primary font-bold px-6 py-2.5"
        [disabled]="!isValid()"
        (click)="onSubmit()"
      >
        <mat-icon class="mr-1.5">send</mat-icon>
        <span>Envoyer l'invitation (3 créneaux)</span>
      </button>
    </div>
  </div>
</aura-dialog-layout>
